export default __webpack_public_path__ + "static/media/expedition.4591294f.jpg";